import { Col, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { sendAlert } from "../../app/alertSlice"
import { selectUserPrivileges } from "../../app/user/userSlice"
import { makeid } from "../../app/utils"
import { routerList } from "../../route/route-list"
import { ALERTCODE_INF } from "../component/AlertMe"
import UserLayout from "../component/UserLayout"
import './UserToolsPage.css'

function hasPrivilege(userPrivilege, requiredPrivilege) {
    return userPrivilege.some(item => requiredPrivilege.includes(item));
}


const constructMenu = (parent, routes, userPrivilege) => {
    let result = [];
    for (const route of routes) {
        if (route.path === '/') continue
        if (route.notShow) continue
        if (route.privilege && !hasPrivilege(userPrivilege, route.privilege)) continue
        if (route.tools) {
            result.push({
                path: parent + route.path,
                tools: route.tools
            })
        }
        if (route.child) {
            let childList = constructMenu(route.path + '/', route.child, userPrivilege)
            if (childList.length > 0) {
                result = result.concat(childList)
            }
        }
    }
    return result
}

export default function UserToolsPage() {
    document.title = '我的工具'
    const hadPrivileges = useSelector(selectUserPrivileges)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const toolsList = constructMenu('', routerList, hadPrivileges)
    const icons = []

    const doJump = async (jumpPrivilege, jumpPrivilegeFailMsg, preJumpCheck, preJumpFailMsg, jumpPath) => {
        if (jumpPrivilege && !hasPrivilege(hadPrivileges, jumpPrivilege)) {
            dispatch(sendAlert({ code: ALERTCODE_INF, msg: jumpPrivilegeFailMsg || "请购买后使用" }))
            return;
        }
        if (preJumpCheck && ! await preJumpCheck()) {
            dispatch(sendAlert({ code: ALERTCODE_INF, msg: preJumpFailMsg || "暂时无法使用" }))
            return;
        }
        navigate(jumpPath);
    }

    for (let i = 0; i < toolsList.length; i++) {
        icons.push(
            <Row key={makeid(5)} xs={3} md={3} className="rowStyle">
                <Col xs={2} md={4}></Col>
                <Col key={makeid(5)} xs={8} md={4}
                    onClick={() => doJump(
                        toolsList[i].tools.jumpPrivilege, toolsList[i].tools.jumpPrivilegeFailMsg,
                        toolsList[i].tools.preJump, toolsList[i].tools.preJumpFailMsg,
                        toolsList[i].path)}>
                    {toolsList[i].tools.icon}
                </Col>
                <Col xs={2} md={4}></Col>
            </Row>
        )
    }

    return (
        <UserLayout>
            <div className="allStyle">
                <Container className="containerStyle">
                    {icons.length > 0 && icons}
                    {icons.length < 1 &&
                        <Row>
                            <Col className="d-flex align-items-center justify-content-center">
                                <h4>暂无可用工具</h4>
                            </Col>
                        </Row>
                    }
                </Container>
            </div>
        </UserLayout>
    )
}